import React from 'react';
import { Volume2, Sparkles } from 'lucide-react';
import { CAALiveDemo } from './CAALiveDemo';
import { CreateCategoryCard } from './CreateCategoryCard';

const HowConectarHelpsSection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-background">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-10 md:mb-12">
          Como o Conectar ajuda no dia a dia
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Card 1 — comunicação, gradiente azul em destaque */}
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-tint via-primary to-primary-ink text-white p-8 flex flex-col gap-5 shadow-[0_30px_80px_-30px_rgba(14,123,239,0.55)]">
            <div
              className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-white/25 blur-3xl pointer-events-none"
              aria-hidden="true"
            />

            <h3 className="relative text-2xl font-bold leading-snug">
              O Conectar{' '}
              <span className="inline-flex items-center gap-1.5 bg-white/20 rounded-full px-3 py-1 text-lg align-middle">
                <Volume2 className="w-4 h-4" />
                fala
              </span>{' '}
              por cada criança
            </h3>
            <p className="relative text-white/85 text-base leading-relaxed">
              Cartões, categorias e voz personalizados para cada perfil — toque num cartão e
              ele fala por ela.
            </p>

            {/* Simulação ao vivo de uma categoria real do app: nome + ícone
                no topo, lista vertical de cartões quadrados embaixo, com
                toque e saída de voz — troca de categoria e repete. */}
            <div className="relative mt-auto">
              <CAALiveDemo />
            </div>
          </div>

          {/* Card 2 — criar categoria, tom quente suave (cor de acento em baixa opacidade, sem borda) */}
          <div className="relative overflow-hidden rounded-3xl bg-warm/[0.07] dark:bg-warm/[0.12] text-foreground p-8 flex flex-col gap-5">
            <div
              className="absolute -bottom-16 -left-16 w-56 h-56 rounded-full opacity-40 blur-3xl pointer-events-none"
              style={{ background: 'radial-gradient(circle, rgb(var(--warm)) 0%, transparent 70%)' }}
              aria-hidden="true"
            />

            <h3 className="relative text-2xl font-bold leading-snug">
              Você tem{' '}
              <span className="inline-flex items-center gap-1.5 bg-warm/15 text-warm-ink dark:text-warm rounded-full px-3 py-1 text-lg align-middle">
                <Sparkles className="w-4 h-4" />
                liberdade
              </span>{' '}
              para criar
            </h3>
            <p className="relative text-muted-foreground text-base leading-relaxed">
              Categorias e subcategorias personalizadas, do jeito de cada criança — dentro de
              uma categoria ou de uma rotina.
            </p>

            {/* Prévia do fluxo real de criação (foto, nome, categoria ou
                rotina, salvar) — ver fragment_config_create.xml do app. */}
            <div className="relative mt-auto">
              <CreateCategoryCard />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowConectarHelpsSection;
